import { render, staticRenderFns } from "./CommercialRibbon.vue?vue&type=template&id=dd238ca8&name=commercial-ribbon&"
import script from "./CommercialRibbon.vue?vue&type=script&lang=js&"
export * from "./CommercialRibbon.vue?vue&type=script&lang=js&"
import style0 from "./CommercialRibbon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports